module.exports = __webpack_public_path__ + "static/media/icon_19px_shopping-cart_white.dd6cef8b.svg";